import React,{useRef} from 'react'
import {Row,Col} from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { useDispatch} from 'react-redux'
import { useSelector} from "react-redux"
import { zapisKonkurs,delKonkurs,modOpcje } from '../Magazyn/kreatorAkcji'

import KonkursAktywny from './konkurs_aktywny'
import KonkursArchiwum from './Konkurs_archiwum'
import {useQuery} from "@apollo/client"
import { GET_Konkursy} from "../Graphql/query"
import Uczestnik from '../Komponenty/uczestnik'
import BladLog from '../Komponenty/BladLogowania'

const Konkurs  = () => {
   const nawigacja = useNavigate()
   const dispach = useDispatch()
   const user    = useSelector((magazyn) => magazyn.uczestnik)
   const zmienne = useRef({variables : {id_uczestnika: user.id},fetchPolicy: 'network-only'})

   const wynik = (event) => {
    let id  = event.target.id
    let obj = {id_konkursu : id}
    dispach(modOpcje(obj))
    let url = `/koniec`
    nawigacja(url)
   }

   const add_Konkurs = (dane) => {
    dispach(delKonkurs(dane))
    dane.uczestnik_konkurs.map(konkurs => dispach(zapisKonkurs(konkurs)) )
   }

   const token = sessionStorage.getItem('token')
   const {data,loading,error} = useQuery(GET_Konkursy,zmienne.current)
   if (loading) { return <p>Wczytywanie danych</p>} else {add_Konkurs(data)}
   if (error) { if(!token) {return <BladLog/>} else { return <p>Błąd połacznia z bazą danych</p>}}
        return(
            <Row>
               {!token ? <BladLog/> :
        <Row>
        <Row><Uczestnik/></Row>
              <Row>
                <Col xs={12}><h2 className='napis'> Lista Aktywnych Konkursów </h2></Col>
              </Row>
              <Row>
              {data.uczestnik_konkurs.map(konkurs => (
                konkurs.status_konkursu === 'A' ?
                <KonkursAktywny key={konkurs.id_konkursu} konkurs={konkurs}/> : ''
                            ))
                          }
              </Row>
              <Row>
                <Col xs={12}><h2 className="napis">Lista Ukończonych Konkursów</h2></Col>
              </Row>
              <Row>
              {data.uczestnik_konkurs.map(konkurs => (
                konkurs.status_konkursu === 'N' ?
                <KonkursArchiwum key={konkurs.id_konkursu} konkurs={konkurs} wynik={wynik}/> : ''
                            ))
                          }
              </Row>
    </Row>
                }
              
            </Row>  
        )
}

export default Konkurs